import { render } from "./CompanySuperAdmin.vue?vue&type=template&id=0f582ca8&scoped=true"
import script from "./CompanySuperAdmin.vue?vue&type=script&lang=js"
export * from "./CompanySuperAdmin.vue?vue&type=script&lang=js"

import "./CompanySuperAdmin.vue?vue&type=style&index=0&id=0f582ca8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f582ca8"]])

export default __exports__